import React from 'react';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent, withDynamicImport } from '@thd-nucleus/app-render';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import {
  Card,
  SkeletonBlock,
  SkeletonLine,
} from '@one-thd/sui-atomic-components';
import { Carousel } from '@one-thd/sui-carousel';
import { DynamicRecsWrapper } from '@thd-olt-component-react/thd-recs-containers';
import {
  DynamicRecsWrapper as DynamicRecsWrapperSSR
} from '@thd-olt-component-react/thd-recs-containers?clientSideRemove';

const placeholderStyles = { height: '183px', width: '183px', alignSelf: 'center' };
const placeholder = (
  <Carousel
    key="placeholder"
    data-component="Dynamic Recs Wrapper Importer"
    className="sui-col-span-12 sui-flex sui-align-center sui-justify-center sui-flex-col"
  >
    <Card>
      <SkeletonBlock aspect="square" style={placeholderStyles} />
      <SkeletonLine variant="multiple" numberOfLines={3} />
    </Card>
    <Card>
      <SkeletonBlock aspect="square" style={placeholderStyles} />
      <SkeletonLine variant="multiple" numberOfLines={3} />
    </Card>
    <Card>
      <SkeletonBlock aspect="square" style={placeholderStyles} />
      <SkeletonLine variant="multiple" numberOfLines={3} />
    </Card>
    <Card>
      <SkeletonBlock aspect="square" style={placeholderStyles} />
      <SkeletonLine variant="multiple" numberOfLines={3} />
    </Card>
    <Card>
      <SkeletonBlock aspect="square" style={placeholderStyles} />
      <SkeletonLine variant="multiple" numberOfLines={3} />
    </Card>
  </Carousel>
);

const ImportedComponent = withDynamicImport({
  server: () => {
    return DynamicRecsWrapperSSR;
  },
  client: () => {
    return import('@thd-olt-component-react/thd-recs-containers');
  },
  placeholder,
  name: 'DynamicRecsWrapper',
});

const HydratedDynamicRecsWrapper = withHydrator({
  id: 'dynamic-recs-wrapper',
  scrollBuffer: 300,
  delay: 1000,
  preserveCtxVal: 'clientStore',
  placeholder
}, ImportedComponent);

const DynamicRecsDynamic = withDynamicComponent(HydratedDynamicRecsWrapper);
const DynamicRecsWrapperImporter = withErrorBoundary(DynamicRecsDynamic);

DynamicRecsWrapperImporter.dataModel = DynamicRecsWrapper.dataModel;
DynamicRecsWrapperImporter.propTypes = DynamicRecsWrapper.propTypes;

export default DynamicRecsWrapperImporter;